module.exports = __webpack_public_path__ + "img/Madagascar.f06d3d46.svg";